import { getImpersonationDetails } from "@fuze/services-auth/dist/token"

export function useIsImpersonating() {
  return !!getImpersonationDetails()
}
